import { useQuery } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Location } from '@/types/types';

export const useLocations = (projectId: number, options?: { enabled?: boolean }) => {
  const { axiosInstance } = useApi();
  return useQuery<Location[]>({
    queryKey: queryKeys.locations.list(projectId).queryKey,
    enabled: options?.enabled,
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/api/v1/projects/${projectId}/locations`);
      return data as Location[];
    },
  });
};

export default useLocations;
